import { render, staticRenderFns } from "./DataPanel.vue?vue&type=template&id=63086a48&scoped=true&"
import script from "./DataPanel.vue?vue&type=script&lang=js&"
export * from "./DataPanel.vue?vue&type=script&lang=js&"
import style0 from "./DataPanel.vue?vue&type=style&index=0&id=63086a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63086a48",
  null
  
)

export default component.exports